

import { call, put, takeLatest, select } from 'redux-saga/effects'
import actionTypes from '../../actions/actionTypes'
import { advertisementsOrderSelector, advertisementsUpdateOrder, removeItemfromArray } from './helpers'


function* deleteAdvertisementsItem(pk) {
    yield put({
        type: actionTypes.ADVERTISEMENTS_DELETE_ITEM,
        meta: {},
        payload: {
            pk: pk
        }
    })
}

function * deleteItem(data) {
    const pk = yield data.payload.pk
    const oldOrder = yield select(advertisementsOrderSelector)
    const newOrder = yield removeItemfromArray(oldOrder, pk)
    
    if(false != newOrder) {
        yield call(advertisementsUpdateOrder, newOrder.toJS())
        yield call(deleteAdvertisementsItem, pk)
    }
}

function* watchDeleteAdvertisement() {
    try {
        yield takeLatest(actionTypes.ADVERTSIEMENTS_REQUEST_DELETE_ITEM, deleteItem)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}


export default watchDeleteAdvertisement;